import { useQuery } from '@tanstack/react-query';
import type { Leco } from '@/api/learning.types';
import { mobietrainFetch } from './rest';
import { useMobietrainUser } from './useMobietrainUser';

interface UseMilestonesOptions {
  enabled?: boolean;
}

export const useMilestones = ({ enabled = true }: UseMilestonesOptions = {}) => {
  const { data: user } = useMobietrainUser({ enabled });
  const userId = user?.userId;

  return useQuery({
    queryKey: ['milestones', userId],
    queryFn: async (): Promise<Leco[]> => {
      const lecos = await mobietrainFetch<Leco[]>(`/rest/users/${userId}/learning-contents`, { method: 'GET' });
      return lecos.filter((leco) => leco.type === 'milestone');
    },
    enabled: enabled && Boolean(userId),
  });
};
